<div class="accordion" id="accordionHelpExample" *ngIf="helpItem == 'stats' || helpItem == 'other'">
  <h1>How to Play</h1>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingOne">
      <button
        class="accordion-button"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapse_help1"
        aria-expanded="true"
        aria-controls="collapse_help1"
      >
        How the Simulation Works
      </button>
    </h2>
    <div
      id="collapse_help1"
      class="accordion-collapse collapse show"
      aria-labelledby="headingOne"
      data-bs-parent="#accordionHelpExample"
    >
      <div class="accordion-body">
        <ul>
          <li tabindex="0">
            Your first task is to analyze your bank's financial and operational situation. You have been put in charge
            of an existing bank and you have a full set of financials. These financials are called the "starting
            position".
          </li>
          <li tabindex="0">
            Upon evaluating the bank’s current position, you should begin to establish specific objectives — that is,
            what you plan to accomplish by the end of your tenure with the bank.
          </li>
          <li tabindex="0">
            Once you know where you are and where you wish to be, you can consider the appropriate strategies, policies,
            and decisions to move your bank in the desired direction.
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingTwo">
      <button
        class="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapse_help2"
        aria-expanded="false"
        aria-controls="collapse_help2"
      >
        Your Bank and the Competitive Environment
      </button>
    </h2>
    <div
      id="collapse_help2"
      class="accordion-collapse collapse"
      aria-labelledby="headingTwo"
      data-bs-parent="#accordionHelpExample"
    >
      <div class="accordion-body">
        <ul>
          <li tabindex="0">
            Banking environment and rules: There are some differences between the accounting rules, regulatory rules and
            tax laws compared to current American banking practices. The banking environment is similar to, but not
            exactly the same as, the American banking situation at the beginning of the 21st century. The rules and laws
            that are in effect are explained in the Participant Decision Manual
          </li>
          <li tabindex="0">
            Economy of the market area: Well diversified and foreign trade is an important component of the economy. You
            will receive information about conditions in the local and national economy for each quarter
          </li>
          <li tabindex="0">
            Business in the area: An automobile assembly plant, aerospace firms, forest and agricultural products
            processors, some technology companies, and a variety of commercial and professional service firms. The
            community is headquarters to several national corporations
          </li>
          <li tabindex="0">
            Other community factors: There is a substantial government sector, several colleges, and a major university
            with a strong health science department
          </li>
          <li tabindex="0">
            As you make your decisions, you will receive competitive information similar to what you receive in the real
            world: loan and deposit rates, money market information, general market information, quarterly financial
            summaries, etc.
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingThree">
      <button
        class="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapse_help3"
        aria-expanded="false"
        aria-controls="collapse_help3"
      >
        Bank Environment History
      </button>
    </h2>
    <div
      id="collapse_help3"
      class="accordion-collapse collapse"
      aria-labelledby="headingThree"
      data-bs-parent="#accordionHelpExample"
    >
      <div class="accordion-body">
        <ul>
          <li tabindex="0">
            As a result of problems over the past two years, the Board of Directors has been forced to bring in a new
            management group. You and your team members are that group. Previous leadership left the bank, leaving no
            continuity within top management
          </li>
          <li tabindex="0">
            Only the financial and operating data for the previous few quarters are relevant and useful to your
            situation, earlier information is of little practical value. Furthermore, you should not take for granted
            prior management's decisions. After all, there is a reason you are taking over the bank!
          </li>
          <li tabindex="0">
            Finally, do not assume that prior management has been totally responsive to the needs of the community.
            There may be important segments of the market that have not been well served in the past and such segments
            may offer opportunities for profitable growth
          </li>
          <li tabindex="0">
            The starting point financial position is the default setting where your BankExec program starts in the
            selected economy. All teams in your program start with these numbers, statistics and policies. These numbers
            and statistics are all as of the end of the year 12/31/30. There is no information regarding the bank prior
            to this starting point except that you're told you are the new management team hired to turn the bank around
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingFour">
      <button
        class="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapse_help4"
        aria-expanded="false"
        aria-controls="collapse_help4"
      >
        Simulation Environment
      </button>
    </h2>
    <div
      id="collapse_help4"
      class="accordion-collapse collapse"
      aria-labelledby="headingFour"
      data-bs-parent="#accordionHelpExample"
    >
      <div class="accordion-body" tabindex="0">
        Although BankExec® is based on a composite of actual banks in the US, you cannot expect it to react to
        decisions exactly as would your own bank. A valuable aspect of the BankExec® experience is managing in a new
        environment that you must assess, understand, and respond to if you are to be successful.
        <ul>
          <li tabindex="0">
            Simply because the simulated environment may happen to resemble one with which you are familiar does not
            mean that traditional strategies will succeed
          </li>
          <li tabindex="0">
            The management team that evaluates its new environment carefully and demonstrates flexibility and
            consistency in making decisions is likely to be, in the long run, the most successful in reaching its goals.
            Your instructor can aid in this process; but ultimately each team is responsible for its own actions and
            learning
          </li>
          <li tabindex="0">
            Competition in your community increases substantially during the simulation. Inactivity or indecisiveness on
            the part of your management may result in the undesired gain or loss of deposits and loans, and if lost, can
            be difficult to regain
          </li>
          <li tabindex="0">
            A set of decisions consistent in strategy from period to period can build momentum, which can increase the
            bank's ability to compete. Once this momentum is working in a bank's favor, other banks must work
            significantly harder to catch up. Of course, the bank that achieves an initial advantage does not
            necessarily have an insurmountable lead, but there is a measurable benefit from logical, consistent action
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingFive">
      <button
        class="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapse_help5"
        aria-expanded="false"
        aria-controls="collapse_help5"
      >
        Business Decisions to Make in BankExec®
      </button>
    </h2>
    <div
      id="collapse_help5"
      class="accordion-collapse collapse"
      aria-labelledby="headingFive"
      data-bs-parent="#accordionHelpExample"
    >
      <div class="accordion-body" tabindex="0">
        After you determine your strategies, it is time to begin making business decisions. In general, you will make
        decisions about:
        <ul>
          <li tabindex="0">Securities purchases and sales</li>
          <li tabindex="0">Loan pricing and terms</li>
          <li tabindex="0">Loan types</li>
          <li tabindex="0">Deposit pricing and terms</li>
          <li tabindex="0">Retail products pricing and terms</li>
          <li tabindex="0">Borrowed funding and dividend policy</li>
        </ul>
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingSix">
      <button
        class="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapse_help6"
        aria-expanded="false"
        aria-controls="collapse_help6"
      >
        Start Position Decisions
      </button>
    </h2>
    <div
      id="collapse_help6"
      class="accordion-collapse collapse"
      aria-labelledby="headingSix"
      data-bs-parent="#accordionHelpExample"
    >
      <div class="accordion-body" tabindex="0">
        Examine the Participant Decision Manual to prepare for your participation in BankExec®. You should be familiar
        with the reporting structure and financial situation of your bank. The knowledge you gain will enable you to
        focus your attention on management of your bank rather than on mechanics of the simulation. Consider the
        following before you begin:
        <ul>
          <li tabindex="0">
            After reviewing your starting position, you are ready to make strategic decisions to affect the performance
            of the bank. These decisions will directly affect the next quarter’s results, but also have long-term
            implications. For example, if you acquire a one-year fixed rate loan, this loan will be on your books for
            one year. If, for example, interest rates go up, you will earn less on this loan than if it had been a
            variable rate loan (all else equal). This type of interest rate risk may be avoided by either matching your
            funding sources or by using variable rate loans that may carry lower interest rates
          </li>
          <li tabindex="0">
            Initial decisions are difficult. Your knowledge of banking from a senior management perspective is critical.
            You are suddenly asked to perform tasks that could be foreign to you. Knowing that the teams you compete
            against are in a similar state of confusion, you must try to anticipate how their decisions will affect your
            team's plans
          </li>
          <li tabindex="0">
            Your unfamiliarity with the BankExec® decision structure, financial statements, and operating
            characteristics may compound problems with decision making. You will also be constrained by time limits,
            making it necessary to organize and use your time efficiently to address the most critical areas
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingSeven">
      <button
        class="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapse_help7"
        aria-expanded="false"
        aria-controls="collapse_help7"
      >
        Financial Forecast Simulations
      </button>
    </h2>
    <div
      id="collapse_help7"
      class="accordion-collapse collapse"
      aria-labelledby="headingSeven"
      data-bs-parent="#accordionHelpExample"
    >
      <div class="accordion-body" tabindex="0">
        After you create a set of decisions, you can "test drive" your decisions to evaluate what may happen in a
        competitive environment by running a "Financial Forecast" simulation. Consider the following:
        <ul>
          <li tabindex="0">
            The total number of Financial Forecast simulations you can run each session may be limited by your
            instructor. There is often a fee charged (established by your instructor) to run the "simulation". Your
            charge for the simulation is listed to the right by Overhead Charge under Run/Submit and Financial Forecast
            simulation and is the running total of the charges for the current quarter
          </li>
          <li tabindex="0">
            A Financial Forecast simulation will run BankExec® with your currently loaded decision set and produce
            output similar to a final submission
          </li>
          <li tabindex="0">
            The competitive environment is one aspect that cannot be predicted in a simulation. The simulation cannot
            estimate what other banks will do in your market. You will manage one of several directly competing banks in
            a community. Your competition is identified at the beginning of the simulation
          </li>
          <li tabindex="0">
            Other banks are managed by teams similar to yours. These banks begin exactly the same as your bank with the
            same size and in the same condition
          </li>
          <li tabindex="0">
            Each competitive bank has approximately 10% of the loans and deposits in the community, and they compete
            directly with each other for customers in the markets they serve. The remaining market share is with "other
            banks and non-bank financial institutions" which operate in this environment as well
          </li>
          <li tabindex="0">
            Additional competition is reflected in the general information you will receive regarding national and
            community economic conditions (Reports C95 and C96)
          </li>
          <li tabindex="0">
            You are not only competing against interest set at the national level, you are also competing against the
            interest rates established by your local competition. Your local competition will adjust their rates and how
            you price your loans and deposits relative to them will be very important
          </li>
          <li tabindex="0">
            When you run a Financial Forecast simulation, you must estimate how competitively your competition will
            price loans and deposits. Just as in the real world, accuracy in estimating what your competition will do
            means more accuracy to estimating your results
          </li>
        </ul>
        <div tabindex="0">
          Prior to submitting your decision set for a "what-if" Forecast simulation, you must estimate the average
          change (from last period) in interest rates you expect from the other banks in your community. The accuracy of
          your "what-if" simulation is highly dependent upon the accuracy of your estimate of your competitor's interest
          rates. Hence, your actual results from a final submission, in which your decisions are run with all other bank
          teams in your community, will not necessarily match those from your simulation.
        </div>
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingEight">
      <button
        class="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapse_help8"
        aria-expanded="false"
        aria-controls="collapse_help8"
      >
        Run/Submit Current Decisions
      </button>
    </h2>
    <div
      id="collapse_help8"
      class="accordion-collapse collapse"
      aria-labelledby="headingEight"
      data-bs-parent="#accordionHelpExample"
    >
      <div class="accordion-body" tabindex="0">
        Under the "Run/Submit" sub menu of the BankExec® program, a link with the description of "Submit Final"
        appears. It has the same function as the button in the "Run Simulations" page called "For Final Submission" and
        on the "Decision Status" page called "Submit Decisions for Final Simulation." Consider the following:
        <ul>
          <li tabindex="0">
            Upon clicking one of the links/buttons the website will check to see if you have approved all of your
            decision forms. If you have not it will direct you to the decision status page where you can do so.
          </li>
          <li tabindex="0">
            After the approval process is complete, you may submit your decisions for final simulation. Upon doing this,
            you will not be able to edit any of the decision forms until the system administrator has run your decisions
            in the simulation program against the other banks
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div tabindex="0" style="opacity: 0"></div>
</div>

<div *ngIf="helpItem == 'plan'" class="Input_Decisions" tabindex="0">
  <div class="help_label" tabindex="0">Input Decisions</div>
  <div tabindex="0">Each team can make operating decisions in the following areas:</div>
  <ul tabindex="0">
    <li>Securities</li>
    <li>Loans</li>
    <li>Deposits</li>
    <li>Treasury Management</li>
  </ul>
  <div tabindex="0">
    These areas are all interdependent in many cases; for example, decisions regarding securities and loans need to be
    coordinated with decisions regarding deposits and treasury management. The general characteristics and the decisions
    associated with each decision area are discussed in separate sections of the Participant manual.<br />

    You may submit an Action Plan for simulation or for final competition. Once you are satisfied with your final
    decision, it is critical that you submit your decision set for final competition. You must submit this final Action
    Plan prior to the final deadline. After the final deadline, all teams in the competition will be run and results
    distributed to you. Failure to submit your final decisions by the deadline will mean that your prior quarter’s
    decisions were used (not your latest decision set)! <br />
  </div>
  <div class="help_label" tabindex="0">General Action Plan Rules</div>
  <div tabindex="0">Follow these guidelines while your team determines an Action Plan:</div>
  <ul tabindex="0">
    <li>
      The majority of decisions represent policies that remain in effect until changed by submission of a new value. All
      prices, budgets, and policy conditions are of this sort. That means that you do not have to enter each and every
      value, only values you want to change.
    </li>
    <li>
      For a decision that will remain in effect, the current value is shown in the box on the form where a new value can
      be entered.
    </li>
    <li>
      If you leave a decision area blank, no entry is made for that decision. Any policy decisions from the prior
      quarter will remain in effect.
    </li>
    <li>
      Follow the format shown for the decision on the form. For example, suppose the current value of a loan interest
      rate is shown as 8.50. If you wish to change the rate to 8.00 percent, write in 8.00 not .08!
    </li>
    <li>
      If no value for a current decision is shown (a blank box in the decision entry area), then a new value must be
      entered each quarter that a decision is desired in this area. If 0.00 is shown, it means that the current value is
      0.00 and this value will remain in effect until changed.
    </li>
    <li>
      Review your decisions for reasonableness in a banking context. Be especially careful if you are making a large
      change from a current value for the decision. Ask your instructor if you have any doubts as to what you are doing.
    </li>
    <li>Save and approve all decision forms even if there are no entries on one or more of them.</li>
  </ul>
</div>

<div *ngIf="helpItem == 'securities'" class="Input_Decisions">
  <div tabindex="0" class="help_label">Buying and Selling Securities</div>
  <div tabindex="0">There are five types of securities that may be purchased and sold:</div>
  <ul tabindex="0">
    <li>Treasury bills (1-4 Quarters)</li>
    <li>Treasury bonds (1-120 Quarters)</li>
    <li>Agency bonds (1-120 Quarters)</li>
    <li>
      State and local governments tax-exempt bonds (Maturity and Available amount noted just below the Security Purchase
      drop-down box and also on B10)
    </li>
    <li>Interest rate swaps (2-80 Quarters)</li>
  </ul>

  <div tabindex="0">
    Securities are purchased and sold in $millions of par (maturity) value. Securities are held to earn interest, help
    meet liquidity needs, speculate on interest rate movements and meet pledging requirements. Investment securities are
    attractive because they earn interest; administration and transaction costs are extremely low (relative to loans);
    and when banks concentrate their purchases on higher-quality instruments, defaults are rare. Institutions can also
    generally sell these securities at predictable prices when they need cash. The market value of investments will vary
    inversely with changes in interest rates. Since investment securities carry fixed coupon rates, when rates fall,
    banks can either earn very attractive yields relative to their borrowing costs or sell the securities at a gain. Of
    course, when rates rise, investment securities decrease in value because they carry below- market interest rates.
    These gains and losses show up on the income statement, B02, as Gains/Losses on Asset Sales. Buying and Selling
    Securities Strategies <br />

    In BankExec®, only Treasury bills and bonds may be used in repurchase agreements. Hold (or purchase) these
    securities in sufficient supplies to perform this function. Pay attention to maturity of treasury securities. For
    example, if $10 million of Treasuries are maturing and they are currently being used for repurchase agreements, the
    bank will have $10 million less available for repurchase agreements in the quarter unless the bank purchases another
    $10 million worth of Treasuries. Other reasons you should consider holding securities:
  </div>
  <ul tabindex="0">
    <li>Securities also represent a good low risk source of income.</li>
    <li>
      Your institutions could realize capital gains if interest rates decrease; i.e., the securities will increase in
      value and could be sold at a profit or your institution could realize a capital loss if interest rates increase.
    </li>
    <li>State and local government bonds earn tax-free interest income.</li>
    <li>Interest rate swaps can be purchased to manage interest-rate risk exposure.</li>
  </ul>

  <div class="help_label" tabindex="0">Gains and Losses on Securities</div>
  <div tabindex="0">
    Selling securities at a profit allows your bank to book gains immediately. If interest rates fall, however, you
    could have sold those same securities for an even great profit later. By holding securities trading above par value
    (with unrealized gains) you are earning interest income that is above market since their coupon payments are above
    comparable securities. By selling securities at a gain you trade booking an immediate gain versus higher future
    interest income.<br />
  </div>

  <div class="help_label" tabindex="0">How is Income Reported for Securities</div>
  <div tabindex="0">
    All securities purchases take place on the first day of the quarter at prices implied by yields that are provided to
    the bank on Report B10. The maturity at purchase can be for any maturity desired (in integer quarters) within the
    limits specified for the security. Since Report B10 shows yields only at a few selected maturities, you must
    estimate the yield for maturities that are not shown. A graph of the yields plotted against maturities may be useful
    for this purpose. This sort of graph is called a "yield curve."<br />

    The cash amount of the purchase is paid immediately. Coupon-bearing securities are priced at their par value and the
    coupon rate is the quoted yield. Treasury bills are priced at a discount from their par value. The decision entry is
    always the amount of par value desired. Therefore the actual cash investment for bills is always less than the
    stated decision by the amount of the discount. Swaps are a special case. There is no initial cash outlay for a swap
    contract. The decision entry is the desired notional amount.<br />
  </div>

  <div class="help_label" tabindex="0">Using Swaps as an Interest Rate Management Tool</div>
  <div tabindex="0">
    The primary use of swaps is to manage interest rate risk exposure. There are two types of swaps available --
    fixed-rate swaps (SF) and variable-rate swaps (SV). In a fixed-rate swap, the bank will receive a fixed coupon
    amount each quarter and pay a variable amount based on the 1-quarter maturity commercial paper rate and the
    "notional" amount of the swap. The rates that apply to new swap purchases are shown on Report B10. The fixed rates
    applying to swaps already in the bank's portfolio are shown as the "Fixed Coupon" in Report B12. The amount of
    interest paid and received is based on the applicable interest rates times the notional amount of the swap. Only the
    net interest is paid or received. For a more detailed explanation of SWAPS see the Decision Manual/Securities
    Decisions/Interest Rate SWAPS<br />

    As an example of the use of swaps in managing interest rate risk, suppose that the bank has a negative 1-quarter
    interest-rate sensitivity gap as reported on B05 equal to -$20 million. Management is concerned about the risk that
    interest rates will rise. Since this gap position implies that $20 million more liabilities than assets will be
    repriced, an increase in interest rates would have an adverse impact on the bank's net interest income. Management
    could choose to protect the bank's earnings from rising interest rates by entering into a $20 million variable-rate
    swap. The interest earned on the variable side of the swap will increase if interest rates rise, whereas the
    interest paid will remain fixed. Therefore, this transaction would help insulate the bank's net interest income from
    interest-rate risk.<br />
  </div>
</div>

<div *ngIf="helpItem == 'loans'" class="Input_Decisions">
  <div class="help_label" tabindex="0">Loan Portfolio</div>
  <div tabindex="0">
    Loans are the major asset in most commercial banks' portfolios and generate the greatest amount of income before
    expenses and taxes. They also exhibit the highest default risk and some are relatively illiquid, although some loans
    can be sold.
  </div>

  <div class="help_label" tabindex="0">Loan Strategy</div>
  <div tabindex="0">
    All loans earn income from the interest rate charged and possibly from origination fees and annual fees. Higher
    rates, relative to the competition, can either mean higher or lower total income. If rates are set too high, demand
    and total interest income will fall. Setting rates too low, relative to the competition, not only means lower income
    but could also mean the bank would see significant loan growth which may have to be funded with borrowings. Rates
    should be set to maximize total income. Origination and annual fees are also competitive, but somewhat less so than
    the actual rates charged.
  </div>

  <div class="help_label" tabindex="0">Basic Loan Decisions</div>
  <div tabindex="0">
    There are four basic loan decisions that must be made for each loan type: the Interest Rate, the Credit Policy, the
    amount to spend on Business Development, and the Maximum Outstanding.
  </div>

  <div class="help_label" tabindex="0">1. Interest Rate</div>
  <div tabindex="0">
    The interest rate decision sets an average rate that applies to customers who are acceptable to the bank as
    indicated by the bank's credit policy. The interest rate is the annual percentage rate charged for loans made in the
    coming quarter. For example, a rate of 6.25% is entered as 6.25. Individual loans may carry higher rates or lower
    rates than the average depending on the credit risk involved. Interest income on all loans is received quarterly.
  </div>

  <div class="help_label" tabindex="0">2. Credit Policy</div>
  <div tabindex="0">
    The credit policy value represents the credit policy of the bank regarding loan customers. The value may range from
    1 to 5. A credit policy of "1" represents a restrictive policy of lending only to customers who are of very high
    credit quality or loans that are extremely well secured. Such customers represent about 20% of the available market.
    There is no appreciable credit risk for loans made under a credit policy of "1." At the other extreme, a credit
    policy of "5" is a liberal policy that permits credit to be extended to all customers with reasonable prospects of
    repayment. The only customers excluded from consideration under this policy are ones who would find it difficult to
    borrow from a bank under any circumstances. Decisions regarding the interest rate and credit policy should be made
    together. The more liberal the bank's credit policy, the higher the average interest rate can be to attract a given
    volume of loans.
  </div>

  <div class="help_label" tabindex="0">3. Business Development</div>

  <div tabindex="0">
    Business development priorities are relative and the decisions in the loan area are affected by business development
    decisions in the deposit area. The budgets are allocated to products as follows:
  </div>
  <ul tabindex="0">
    <li>None has a value of 0</li>
    <li>Low has a value of 1</li>
    <li>Medium has a value of 2</li>
    <li>High has a value of 4</li>
  </ul>

  <div tabindex="0">
    A product with a High decision will have a budget that is four times that of a product with a Low decision. The
    actual amounts involved depend on the level of the budget decisions. If all the decisions are the same, then the
    budgets are allocated equally to each product. Choosing none means that no money will be spent on this product. Loan
    officers will simply devote all their time to servicing existing customers. No time will be spent on developing new
    accounts.
  </div>

  <div class="help_label" tabindex="0">4. Maximum Outstanding</div>
  <div tabindex="0">
    Maximum Outstanding is the maximum amount of total loans for each loan type that management wishes to have,
    expressed in millions. The limit does not apply to credit line draws under existing commitments and it does not
    affect the pattern of repayments of outstanding loans. The limit can impact the amount of new loans booked.<br />

    For example, a value of 120 for Commercial Real Estate loans sets an intended ceiling of $120 million outstanding
    for this loan type. If the current balance is below $120 million, new loans will be limited if they would cause the
    total balance to exceed $120 million. If the current balance exceeds $120 million, new loans may be forced to
    zero.<br />

    Standard Loan Products There are nine potential loan products that may be offered by the bank: A minimum number of
    five standard products and four that may or may not be available up to a maximum of seven. The five loan products
    are: Business Term Loans, Business Credit Lines, Commercial Real Estate Loans, Fixed-Rate Residential Mortgages, and
    Consumer Instalment Loans. The four optional loan types are Agricultural Loans, Variable-Rate Mortgages, Home Equity
    Credit Lines, and Credit Cards.
  </div>

  <div class="help_label" tabindex="0">1. Business Term Loans</div>
  <div tabindex="0">
    Business term loans require regular principal payments equal to the initial amount of the loan divided by the
    initial maturity. They have a maximum maturity of 20 quarters. There is some demand for 8-quarter term loans. The
    bank's interest rate and credit-quality decisions apply only to the loans made in the quarter for which the
    decisions are in effect. The bank earns a 1.50% origination fee on all new business loans.<br />

    The interest rate charged on term loans is tied to the prime rate. The bank's current interest rate determines the
    spread relative to the current prime rate. For example, if the bank's decision rate is 7.00% and the prime rate is
    6.25%, the spread is +0.75%. As the prime rate changes each quarter, business term loans in the bank's portfolio are
    charged an annual interest rate equal to the original spread on the loan plus the current prime rate. So, if the
    prime rate at the beginning of the next quarter is 6.50%, terms loans made with a spread of 0.75% would have a new
    annual rate of 7.25%. Therefore business term loans are inherently 1-quarter variable rate loans.<br />
  </div>

  <div class="help_label" tabindex="0">2. Business Credit Lines</div>

  <div tabindex="0">
    A business credit line does not require any principal payments prior to its maturity. Loans outstanding under credit
    lines average about 50% of the total commitments outstanding and is somewhat seasonal with the first quarter of the
    year having the lowest usage and the fourth quarter having the highest. Credit lines have a maximum maturity of 12
    quarters. Customers may choose shorter maturities if they prefer. There is some demand for 4-quarter credit lines.
    The bank earns a 1% annual maintenance fee on credit lines. The bank's interest rate and credit-quality decisions
    apply only to the loans made in the quarter for which the decisions are in effect. The bank earns a 1.50%
    origination fee on all new business credit lines. This fee is based on the amount of the commitment made, not the
    amount of the loan initially drawn down by the customer.<br />

    The interest rate charged on business credit lines is tied to the prime rate. The interest rates specified as the
    bank's current decisions sets the spread relative to the current prime rate. For example, if the bank's decision
    rate is 6.50% and the prime rate is 6.25%, the spread is +0.25%. As the prime rate changes each quarter, credit
    lines in the bank's portfolio are charged an annual interest rate equal to the original spread on the loan plus the
    current prime rate. So, if the prime rate at the beginning of the next quarter is 5.50%, loans made with a spread of
    0.25% would have a new annual rate of 5.75%. Therefore credit lines are inherently 1-quarter variable rate loans.
    <br />

    Credit lines and term loans are relatively close substitutes from the perspective of the bank's business customers
    although there are preferences for one over the other for many customers. There is more demand for credit lines than
    for term loans; but the bank's policies can influence the choice made by customers for these two products. For
    example, if the bank offers unusually attractive terms on its term loans relative to its credit lines, many
    customers will choose term loans. Therefore, management should consider both products together in its approach to
    this market.<br />
  </div>

  <div class="help_label" tabindex="0">3. Commercial Real Estate Loans</div>
  <div tabindex="0">
    Commercial real estate loans are secured by real property. New loans have a 2% origination fee and these loans may
    be sold. There are two decisions that apply only to these customers in addition to the four standard ones--maximum
    maturity and rate adjustment period. <br />

    <b>Maximum Maturity</b>
    The maximum maturity decision is in quarters and can be any value from 01 to 99 quarters. The maturity decision
    applies only to loans made in that quarter. No adjustment can be made to the terms of loans made in prior
    quarters.<br />

    The maturity decision affects the type of loan made. Loans of 8 quarters or less, are used for purposes such as
    construction of new buildings or the purchase of land to be used in development. Loans with maturities between 8
    quarters and 21 quarters will be amortized over a period of 40 quarters with the balance due at maturity. If the
    maximum maturity is 21 quarters or more, loans made with the maximum maturity will be amortized over 80 quarters
    with the remaining balance due at maturity. Since all three types of loan may be demanded in the market, if the
    maximum maturity decision is 20 quarters or less, the bank is limiting the type of borrower to which it is willing
    to lend. If the bank sets the maximum maturity decision greater than 20 quarters, all types of customers can be
    accommodated. A maximum maturity decision of 40 quarters will meet the needs of all customers, and very few
    customers are willing to borrow at a maturity of less than 4 quarters.<br />

    <b>Rate Adjustment Period</b>
    The rate adjustment period decision is in quarters and can be any value from 01 to 99 quarters. When a real estate
    loan is made, a spread is calculated against the rate on a Treasury bond with the same maturity as the rate
    adjustment period for the loan--the "index rate". The borrower is then charged the bank's decision rate until the
    rate adjustment period expires. At this time, the original spread is added to the value of the index rate. For
    example, suppose that the rate adjustment period is four quarters. If you make a loan today at an interest rate of
    9.00% and the current 4-quarter Treasury bond rate is 7.00%, the spread on the loan will be 2.00%. The annual
    interest rate on the loan will be fixed at 9.00% for the next four quarters. Four quarters from now, a new rate will
    be established for the loan. If the 4-quarter Treasury bond rate at that time is 7.50%, the loan will have a new
    interest rate of 9.50% that will remain fixed for the following four quarters. If the rate adjustment period is
    equal to the maximum maturity decision, the bank is making fixed rate commercial real estate loans.<br />
  </div>

  <div class="help_label" tabindex="0">4. Fixed-Rate Residential Mortgages</div>
  <div tabindex="0">
    Fixed-rate residential mortgages are made at the current interest rate decision of the bank and have maturities of
    60 quarters and 120 quarters. They are repaid in equal quarterly instalments of principal plus interest. These loans
    are all secured by 1-4 family homes and tend to be the safest loan made by the bank. Borrowers may repay ahead of
    schedule, especially if interest rates decrease significantly. The bank earns origination fees of 2% on all new
    residential mortgages and these loans may be sold.
  </div>

  <div class="help_label" tabindex="0">5. Instalment Loans</div>

  <div tabindex="0">
    Consumer instalment loans are fixed rate, level payment, and amortized loans. They are predominately secured by
    consumer durable goods. They carry initial maturities of 8 quarters to 20 quarters. The demand for these loans is
    rather seasonal in that new loan demand is about 20% lower during the first quarter of the year compared to other
    quarters.<br />
  </div>

  <div class="help_label" tabindex="0">Additional Loan Types</div>

  <div tabindex="0">
    There are four types of loans that could be available to the bank depending on the particular program focus:
    Agricultural Loans, Variable-Rate Residential Mortgages, Home Equity Credit Lines, and Credit Cards.
  </div>

  <div class="help_label" tabindex="0">1. Agricultural Loans</div>

  <div tabindex="0">
    Agricultural loans are credit lines to farmers and farming companies. These loans are credit lines with a commitment
    of one year. They are similar to credit lines for business firms with some differences. Initial commitments and
    credit line draws on agricultural loans follow a seasonal pattern. Most of the initial commitments are made in
    January through June. Draws take place most heavily in March through September. These loans typically reach their
    maximum level at the end of September, then decrease to relatively low levels at the end of December through and the
    end of February. <br />

    Agricultural credit lines carry an interest rate that varies with the prime rate. Also, they all have an initial
    maturity of 4 quarters. The bank earns a 1.50% origination fee on new credit lines extended. The fee is based on the
    size of the commitment, not the amount initially loaned. The fees earned in the current quarter are therefore 1.50%
    of the amount of new commitments.<br />
  </div>

  <div class="help_label" tabindex="0">2. Variable-Rate Residential Mortgages</div>
  <div tabindex="0">
    Variable-rate mortgages appeal to a somewhat different customer than fixed-rate mortgages although these two
    products are substitutes; that is, both products serve the needs of the 1-4 family financing market. The interest
    rate posted by the bank sets a spread against the 4-quarter U.S. Treasury rate. Each year, on the anniversary date
    of the mortgage, the interest rate is re-set to be the current rate on 4-quarter U.S. Treasuries plus the spread.
    These mortgages are re-amortized when the rate changes to avoid "negative amortization" from an increase in interest
    rates. Variable-rate mortgages have original maturities of 60 and 120 quarters.<br />
  </div>

  <div class="help_label" tabindex="0">3. Home Equity Credit Lines</div>
  <div tabindex="0">
    Variable-rate mortgages appeal to a somewhat different customer than fixed-rate mortgages although these two
    products are substitutes; that is, both products serve the needs of the 1-4 family financing market. The interest
    rate posted by the bank sets a spread against the 4-quarter U.S. Treasury rate. Each year, on the anniversary date
    of the mortgage, the interest rate is re-set to be the current rate on 4-quarter U.S. Treasuries plus the spread.
    These mortgages are re-amortized when the rate changes to avoid "negative amortization" from an increase in interest
    rates. Variable-rate mortgages have original maturities of 60 and 120 quarters.<br />
  </div>

  <div class="help_label" tabindex="0">4. Credit Cards</div>
  <div tabindex="0">
    Credit cards do not "mature" in any meaningful sense. Customers in good standing have their cards renewed at the
    expiration dates which range from 4 to 8 quarters. Therefore the balances and outstanding credit card lines tend to
    be ongoing. Each customer has a credit limit similar to those established for business credit lines. Credit cards
    have an additional decision: An annual fee may be charged. <br />

    The bank earns interest only on those credit card accounts that are not paid in full each month. The total balance
    outstanding reflects both current balances and balances earning interest. In addition the bank receives income from
    merchant discounts at a rate of 1.50% of credit card billings for the quarter. The interest rate applicable each
    quarter to those accounts paying interest is the current decision rate. A change in the rate charged applies to all
    accounts except those of customers who pay their entire balance monthly. Credit cards tend to have the highest
    charge-off rate of any loan that is made by the bank.<br />

    Some customers may pay off the bank entirely during the quarter. The decision by customers to substantially reduce
    or eliminate their credit card balances is sensitive to the interest rate charged by the bank relative to
    alternatives available in the market. Remember, most credit card customers carry more than one credit card and many
    have alternative loan sources such as home equity credit lines. <br />

    Annual Fee An annual fee may be charged to credit card customers. The decision is entered in $ per year; for
    example, a decision of 15 is a fee of $15 per year per account. Credit card fees are assessed annually on each
    account at the current annual fee charged. Roughly 25 percent of continuing old customers will pay the fee each
    quarter. New customers pay the fee in the quarter their account is opened.
  </div>

  <div class="help_label" tabindex="0">Loan Sales Decisions</div>
  <div tabindex="0">
    Individual residential mortgages and commercial real estate loans currently in the bank's portfolio may be sold in
    pre-set packages (listed in Report B24). The bank will receive the market value of the package on the first day of
    the quarter in which it is sold. There are never more than eight loan sale packages and the packages available
    change each quarter. Sales are made without recourse to the bank, but only performing loans may be sold. The market
    demand for the packages is sensitive to the maturity and the price offered depends on the credit quality of the
    loans. Customers for these packages do a "due diligence" examination of the loan documents and assesses the credit
    risk of the borrowers. Longer maturities are usually more acceptable. The bank retains the servicing on all loans
    sold and earns an annual fee of 0.80% of the outstanding balance for this service.
  </div>

  <div class="help_label" tabindex="0">Provision for Loan Losses</div>
  <div tabindex="0">
    The provision for loan losses on the bank's income statement is determined by a regulatory requirement that the bank
    maintain a loan loss reserve of at least 1.00% of total loans. When loans are increasing, the loan loss reserve will
    be exactly 1.00% of total loans. If loans increase by $50 million, the loan loss reserve must increase by $500,000
    or $0.50 million. Loan charge-offs are deducted from the reserve each quarter. Therefore, the provision for loan
    losses will equal any required additions to the reserve plus charge-offs. In a quarter when loans increase by $50
    million and charge-offs are $300,000, the provision for loan losses would be $800,000 ($0.80 million = $0.50 million
    + $0.30 million). The accounting rules for the bank do not permit negative provisions for loan losses. If loans are
    decreasing and charge-off are small, the provision for loan losses may be zero, and the reserve for loan losses may
    be greater than 1.00 percent of total loans. No additional provisions will be required in this situation until the
    loan loss reserve is reduced to 1.00%.
  </div>
</div>

<div *ngIf="helpItem == 'deposits'" class="Input_Decisions">
  <div class="help_label" tabindex="0">Deposit Market Strategy</div>
  <div tabindex="0">
    The bank seeks retail deposits as a less expensive and less risky source of funding as compared to large negotiable
    certificates of deposits (CDs) (purchased funds) as described in the Treasury Management section. Expenses on
    deposits are composed of the interest rate paid (which can be two-tier rate) as well as business development
    expenses. The bank, in addition, can earn income from fees charged on the accounts; e.g., monthly fee; per item
    debit fee.<br />

    The bank acquires deposits from two types of customers--businesses and individuals. There is a wide variety of
    customers with differing account characteristics. For example, some customers keep relatively large deposit balances
    with the bank, others keep relatively small balances.<br />
  </div>

  <div class="help_label" tabindex="0">Deposit Types</div>

  <div tabindex="0">There are four different deposit products that are available to bank customers:</div>

  <div class="help_label" tabindex="0">1. Checking Accounts</div>
  <div tabindex="0">
    The bank offers checking accounts separately to businesses and individuals with separate pricing policies. The level
    of business checking accounts depends in part on the business loan policies of the bank and the specific deposit
    decisions. The level of individual checking accounts depends primarily on the deposits decisions--there is little
    impact from individual loan policies. The four decisions for checking accounts are:
    <b>1. Monthly Fee</b>
    The monthly fee is in dollars per month and is assessed against each account during the quarter. For example, a
    decision of 10.00 is a fee of $10 per month per account. When a new fee is charged, it applies immediately to all
    accounts.<br />

    <b>2. Item Charge</b>
    The item charge is in dollars per item and applies immediately to all accounts. Each check processed through the
    account is an "item"; therefore an item charge of .08 is a charge of $0.08 per check processed. The maximum item
    charge is $0.99.<br />

    <b>3. Interest Rate</b>
    The interest rate is stated as an annual percentage rate. For example a decision of 2.50 provides customers with
    annual interest of 2.50 percent of the average balances in their accounts. Interest is computed quarterly at the
    annual rate in effect for the quarter divided by 4. Business checking accounts are not paid explicit interest; the
    interest rate for them is a credit against service charges. Therefore the service charges shown for business
    accounts on B40 are net of the credits. Individual checking accounts that exceed the minimum balance (see this
    decision below) are paid interest, which is shown separately on B40.<br />

    <b>4. Business Development</b>
    The business-development decision for deposit accounts is the same as that for loans. It sets a priority for the
    business development budget. The choices available are High (H), Medium (M), Low (L), and None (N). Loan and deposit
    business development decisions should be coordinated.<br />

    <b>5. Minimum Balance </b>
    The interest rate is stated as an annual percentage rate. For example a decision of 2.50 provides customers with
    annual interest of 2.50 percent of the average balances in their accounts. Interest is computed quarterly at the
    annual rate in effect for the quarter divided by 4. Business checking accounts are not paid explicit interest; the
    interest rate for them is a credit against service charges. Therefore the service charges shown for business
    accounts on B40 are net of the credits. Individual checking accounts that exceed the minimum balance (see this
    decision below) are paid interest, which is shown separately on B40.<br />
  </div>

  <div class="help_label" tabindex="0">2. Savings Accounts</div>
  <div tabindex="0">
    Savings accounts have limited withdrawal so they are not a good substitute for checking accounts for most
    individuals. Some businesses will use these accounts for a liquid, interest-bearing investment. The bank may charge
    a monthly fee for this service and there is a business-development decision with the same characteristics as the
    comparable decisions for checking deposits. The interest rate paid on this account, however, may depend on the
    minimum balance in the account. Therefore there are two interest rate decisions as shown on the Decision Form.<br />

    <b>1. Interest Rate</b>
    The minimum interest rate paid on all accounts for the quarter. The decision is entered as an annual percentage
    rate. A decision of 2.50 indicates that interest will be paid during the quarter at an annual rate of 2.50%, or
    0.625% per quarter. Interest is paid quarterly on all accounts at the current rate in effect for the quarter that is
    applicable to each account.<br />

    <b>2. Premium Rate</b>
    An interest rate that applies to the entire balance for accounts that maintain the specified minimum balance,
    entered as the annual percentage rate. If this rate is less than the interest rate on the account, the decision has
    no effect.<br />

    <b>3. Minimum Balance</b>
    The minimum balance required to qualify the account for the premium interest rate. The decision is in dollars. For
    example, a decision of 1000 means that the minimum balance required is $1000. A minimum balance of 0 means that all
    accounts receive the premium rate. A break-out of the accounts receiving the "standard" interest rate and the
    premium rate is shown on Report B40, lower right.<br />
  </div>

  <div class="help_label" tabindex="0">
    3. Fixed Rate and Variable Rate Savings Certificates (Retail Time Deposit Accounts)
  </div>
  <div tabindex="0">
    All of these deposit sources are considered "core deposits" in that a customer relationship based on factors other
    than price is involved and these customers often use more than one product or service offered by the bank. For
    example, roughly 75 percent of business checking deposits will come from customers who also borrow from the bank.
    Business customers also keep time and savings deposit accounts with the bank. Individuals may also be borrowers and
    are likely to keep more than one type of deposit account at the bank.<br />

    The bank can offer two types of retail time deposit accounts: <br />

    <b>1. Variable-rate Retail Time Deposits</b>
    Variable-rate retail time deposits pay a rate of interest that is indexed to the interest rate on 1-quarter Treasury
    bills (T-bills). The spread on new deposits, which can be positive or negative, is set by the bank's interest rate
    decision for these accounts. Thereafter, until maturity, the interest paid quarterly is one fourth of the current
    annual rate on the T-bill plus the spread that was set at the time the deposits were made. For example, suppose that
    the bank's decision rate is 4.25% and that the T-bill rate is 5.00%. The spread set on new deposits during this
    quarter will be -0.75%, a negative number. These deposits will carry an annual interest rate that is always 75 basis
    points—0.75%— less than the T-bill rate each quarter. However, note that if the T-bill rate in the next quarter
    falls to 4.00% and the bank keeps the decision rate at 4.25%, all new deposits made in that quarter will carry a
    spread of +0.25%. The bank will pay interest of these deposits at an annual rate that is 25 basis points greater
    than the T-bill rate in future quarters. Therefore, the interest rate decision must be changed whenever the T-bill
    rate changes if the bank wishes to keep a constant spread on these accounts. A decision of 0.00 means that the bank
    does not offer variable-rate time deposits.<br />

    Variable-rate retail time deposits remain with the bank until their maturity as established by the maturity decision
    at the time they were received. Once issued, the maturity of a deposit cannot be changed by the bank or by the
    customer. There are no early withdrawals from these accounts.<br />

    <b>2. Fixed-rate Retail Time Deposits</b>
    The bank can offer up to three different fixed-rate retail time deposit certificates each quarter. Since management
    has a great deal of flexibility with this product, the rules for entering decisions must be followed carefully. If
    no entry for maturity or interest rate, is made, whatever decisions were in effect for the prior quarter are carried
    over. To eliminate a fixed rate retail time deposit use the "clear row" link. However, any change in the
    certificates offered must be made according to these rules:
  </div>
  <ul tabindex="0">
    <li>
      If there is a zero value for last quarter's decision on a line, both maturity and interest rate decisions must be
      entered to have a valid certificate.
    </li>
    <li>If a zero is entered for maturity or rate, no certificates of this type will be offered in the quarter.</li>
    <li>
      If one or more of the decisions for a certificate is left blank, the values for the last quarter will remain in
      effect.
    </li>
  </ul>
  <div tabindex="0">There are four decisions that apply to these deposits:</div>

  <div class="help_label" tabindex="0">1. Maturity</div>
  <div tabindex="0">
    This is the original maturity of the deposit in quarters, which may be any value from 0 to 40. For example, a
    decision of 20 provides a certificate with a 20-quarter maturity. There is currently a regulatory maximum maturity
    of 40 quarters for bank time deposits. A decision of 0 (zero) means that the bank does not offer this type of
    deposit.
  </div>

  <div class="help_label" tabindex="0">2. Interest Rates</div>
  <div tabindex="0">
    The minimum interest rate paid on all accounts for the quarter. The decision is entered as an annual percentage
    rate. A decision of 2.50 indicates that interest will be paid during the quarter at an annual rate of 2.50%, or
    0.825% per quarter. Interest is paid quarterly on all accounts at the current rate in effect for the quarter that is
    applicable to each account.
  </div>

  <div class="help_label">3. Business Development</div>
  <div tabindex="0">
    The business-development decision for deposit accounts is the same as that for loans. It sets a priority for the
    business development budget. The choices available are High (H), Medium (M), Low (L), and None (N). Loan and deposit
    business development decisions should be coordinated.
  </div>

  <div class="help_label">4. Maximum Issue</div>
  <div tabindex="0">
    The maximum issue decision limits the amount of new deposits issued in a single certificate. Management may choose
    to limit the amount when they are offering an unusually attractive interest rate to new depositors. The maximum
    amount of new deposits in a certificate that the bank wishes to accept in the quarter is entered into the decision
    form in millions of dollars. For example, a decision of 10 is $10 million. The amount entered may be any number from
    0 to 99 million. A decision of 0 (zero) means that the bank is not willing to accept any certificates of this type
    during the quarter and a decision of 99 means that the bank will accept all that are offered. It is highly unlikely
    that the possible deposits in a single certificate will ever exceed $99 million.<br />

    Business-development priority is a single decision applying to all time deposits. The business development decision
    and interest rate decisions are entered like those for the other deposit accounts; the maturity and maximum issue
    decisions are new.<br />

    All of these deposit sources are considered "core deposits" in that a customer relationship based on factors other
    than price is involved and these customers often use more than one product or service offered by the bank. For
    example, roughly 75 percent of business checking deposits will come from customers who also borrow from the bank.
    Business customers also keep time and savings deposit accounts with the bank. Individuals may also be borrowers and
    are likely to keep more than one type of deposit account at the bank.
  </div>
</div>

<div *ngIf="helpItem == 'treasuries'" class="Input_Decisions">
  <div class="help_label" tabindex="0">Treasury Management</div>
  <div tabindex="0">
    The treasury management function covers a variety of purchased funds sources and capital issues. Purchased funds are
    available at current market rates, are not dependent on the actions of other banks in the community, rather the
    financial condition of your bank. Financially strong banks can purchase funds at lower rates and higher volumes than
    financially weak banks. The bank has five discretionary sources of funds available to it--repurchase agreements,
    certificates of deposit, Federal Home Loan Bank borrowing, capital notes, and common stock. Capital notes and common
    stock are sources of capital for the bank. These sources are used infrequently. The bank does not have direct
    control of Fed as these are used to balance the bank's balance sheet.
  </div>

  <div class="help_label" tabindex="0">Purchased Funds Available</div>
  <div tabindex="0">
    For the remaining purchased funds, the bank simply requests the type of funds desired, the amount (with some
    limitations), and the maturity:
  </div>

  <div class="help_label" tabindex="0">Repurchase Agreements (repos) and Federal Funds</div>
  <div tabindex="0">
    Management may acquire funds by entering into repurchase agreements or "repo's". The desired amount is entered in
    millions of dollars, and the amount borrowed from this source will be continuously outstanding during the quarter.
    Only US Treasury bills and bonds can be used in repurchase agreements. If the decision entry is greater than the
    maximum available, the actual amount will be this maximum. The amount shown as "available" in Report B64 is the
    current market value of the Treasury securities in the bank's portfolio that are not maturing this quarter. The
    actual amount that will be available is the value shown plus any current quarter purchases less any sales.
  </div>
  <div class="help_label" tabindex="0">Certificates of Deposit (CDS)</div>
  <div tabindex="0">
    CDs may be issued in maturities of 1, 2, 3, and 4 quarters. The amounts and rates available are shown on Report B64.
    The amounts shown are absolute upper limits. Requests for CDs in excess of those amounts will not be honoured, and
    the maximum available will be issued. The amount desired for each maturity is entered in millions of the currency
    desired and may be any amount in even millions up to the maximum shown. Fractional amounts (for example, 8.50) are
    NOT acceptable decisions. If a space is left blank, no CDs of that maturity will be issued. Each bank will have a
    unique schedule of CDs available. The rates and amounts will depend on the size of the bank (large banks will have
    more available than small banks), past issues (the potential total amount outstanding is limited), and the market's
    assessment of the risk of the bank as indicated by its credit rating shown on Report C94, which will affect both
    rates and volume available to the bank. Once issued, CDs will remain until maturity. Interest is accrued quarterly
    with the entire principal and interest payment made at maturity.
  </div>
  <div class="help_label" tabindex="0">FHLB Debt</div>
  <div tabindex="0">
    The bank is initially a member of the Federal Home Loan Bank (FHLB). To remain an FHLB member the bank must maintain
    at least 10% of total assets in "Qualified Housing Assets" defined as residential mortgages (including those that
    were sold and are being serviced) and home equity loans. Failure to maintain this ratio can result in withdrawal of
    membership, which would eliminate future advances. The bank regulatory agency is responsible for overseeing
    compliance with FHLB rules. Membership entitles the bank to have borrowed fixed-rate long-term debt with a 40
    quarter maturity at relatively attractive rates that are not dependent on the credit rating of the bank. The
    aggregate amount of FHLB borrowings that can be outstanding depends on the credit rating of the bank and the amount
    of residential mortgages held by the bank in its portfolio at the end of each quarter. The rate on a borrowing
    contract is priced as a spread added to the current rate on US Treasury bonds for the contract maturity. The spread
    equals 25 basis points plus 2 basis points per year to maturity. For example, the spread on a 20 quarter (5 year)
    contract would be 35 basis points. If the current rate on 20 quarter US Treasury bonds is 5.50%, the bank could
    obtain 20 quarter fixed rate financing from the FHLB for 5.85%. Residential mortgages are used to secure the debt.
    The maximum amount of new advances under the program and the current interest rate is shown on Report B64.
  </div>
  <div class="help_label" tabindex="0">Capital Notes and Common Stock Issues</div>
  <div tabindex="0">
    Capital notes and common stock are external sources of bank capital. The other source of capital is retained
    earnings generated by the bank's operations, an "internal" source. A decision to raise new capital from external
    sources should not be taken casually and should be made in light of the bank's strategic plan.<br />
  </div>
  <div tabindex="0">
    <b>1. Capital Notes</b>

    The bank may raise capital by issuing long-term debt in the form of subordinated capital notes or common stock.
    Capital notes pay a fixed rate of interest quarterly and have a single principal payment due 60 quarters from the
    date of issue. If management wishes to issue capital notes, it may choose from a range of amounts as shown on Report
    B64 and the Treasury Decision Form. Only one issue of capital notes may be made in any quarter. The interest rate
    the bank will pay for any amount within the range are shown on the reports. The amount desired is entered in the
    space provided in millions of dollars. The amount entered must be in whole numbers, no fractional amounts and within
    the ranges of amounts shown. Any decision that does not match will be ignored, and no issue will be made. Interest
    rates on capital note issues are the effective rates after issue costs and reflect both the financial soundness of
    the bank and capital market conditions. Therefore, the rates available depend on the credit quality of the bank. The
    market for note issues may be limited in amount. If "N/A" is showing for the interest rate, it means that amounts in
    this range are not available.
  </div>

  <div tabindex="0">
    <b>2. Common Stock Issues</b>

    The bank may also issue common stock for amounts within the ranges shown on form B64 and the Treasury Decision Form.
    The rules regarding the amount of common stock to be issued are the same as those for capital notes described above.
    Only one amount can be entered, and it must match one of the amounts shown. The issue price per share reflects the
    net proceeds to the bank after all expenses and can be used to determine the number of shares that must be issued to
    raise a given amount. For example, suppose that you wish to raise $5 million in common stock and that the issue
    price for an issue of $5 million is $25.00 per share. The number of shares that will be issued is $5 million divided
    by $25, which equals 200,000 shares. The variation in the issue price per share for different issue amounts is due
    to two partially offsetting factors. First, the market absorbs small issues more easily than it does large issues
    and, second, the costs of issuing stock decline as a percentage of the amount issued as the amount issued increases.
  </div>

  <div class="help_label" tabindex="0">Dividends Per Share</div>
  <div tabindex="0">
    This is entered in dollars per share (for example, a decision of 0.25 is a dividend per share for the coming quarter
    of $0.25) and remains in effect until changed by a new decision. The dividend decision establishes a policy that is
    communicated to investors as being the "regular" dividend of the bank. Investors expect management to maintain
    dividends at the level announced or increase them in the future. A reduction in dividends is considered by investors
    to be a signal that management is pessimistic about the future profits of the bank and can have a significant
    adverse impact on the bank's stock price. Therefore, dividends should be set at a sustainable level and maintained
    whenever possible.
  </div>
  <div class="help_label" tabindex="0">Earnings Per Share Forecast</div>
  <div tabindex="0">
    A forecast of the earnings per share of common stock (EPS) for the next quarter is required. Unless changed, the
    forecast for the current quarter (quarter just ended), which is shown below the decision entry area, will be used.
    The amount is to be entered in dollars. For example, a forecast of 0.60 is $0.60. To show that a loss of that amount
    is expected, place minus sign in front of the figure. The forecast is communicated to security analysts and used by
    investors in the bank's stock to evaluate the ability of management. Poor forecasts will adversely impact the price
    of the bank's common stock, especially if the forecast is much higher than actual EPS. Actual earnings per share for
    the current quarter are shown on the Output Data, Treasury Management Form-B64 next to the decision entry area and
    on Community Bank Capital Activity under the Earnings Per Share column.
  </div>
</div>
